/* PiiGAB Wishlist / Inköpslistor controller
   - Reads SSR state from <script data-wishlist-state>
   - Talks to App Proxy endpoint (piigab-wishlist) for all mutations
   - Syncs hearts, renders the drawer, moves items to cart (with config replay) */
(function () {
  'use strict';

  var DEFAULT_ENDPOINT = '/apps/piigab/piigab-wishlist';
  var LS_ACTIVE = 'wubs_wishlist_active_list';

  var state = { wishlist: { v: 1, lists: [] }, active: null, busy: false, open: false, shared: null };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function drawerEl() { return qs('[data-wishlist-drawer]'); }
  function endpoint() { var d = drawerEl(); return (d && d.dataset.wishlistEndpoint) || DEFAULT_ENDPOINT; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Translatable labels — rendered from theme settings as <script data-wishlist-labels>.
  // Falls back to the Swedish default in code if a label is missing.
  var L = (function () { var el = qs('[data-wishlist-labels]'); var d = {}; if (el) { try { d = JSON.parse(el.textContent.trim()) || {}; } catch (e) {} } return d; })();
  function t(key, fallback) { var v = L && L[key]; return (v === undefined || v === null || v === '') ? fallback : v; }

  function loadInitial() {
    if (!isLoggedIn()) {
      state.wishlist = guestRead();
    } else {
      var el = qs('[data-wishlist-state]');
      if (el) { try { state.wishlist = JSON.parse(el.textContent.trim()); } catch (e) {} }
    }
    if (!state.wishlist || typeof state.wishlist !== 'object') state.wishlist = { v: 1, lists: [] };
    if (!Array.isArray(state.wishlist.lists)) state.wishlist.lists = [];
    var stored = localStorage.getItem(LS_ACTIVE);
    var exists = stored && state.wishlist.lists.some(function (l) { return l.id === stored; });
    state.active = exists ? stored : (state.wishlist.lists[0] && state.wishlist.lists[0].id) || null;
  }

  // Product ids whose "never show price" rule applies. Seeded from the drawer
  // (already-saved rows) and extended when a heart carrying the flag is clicked.
  var noPriceIds = (function () {
    var map = {};
    var el = qs('[data-wishlist-nopricing]');
    if (el) {
      try {
        (JSON.parse(el.textContent.trim()) || []).forEach(function (id) {
          if (id) map[String(id)] = true;
        });
      } catch (e) {}
    }
    return map;
  })();
  function hidesPrice(it) { return !!noPriceIds[String(it && it.product_id)]; }
  // Prices are B2B-only everywhere else in the theme; the drawer must match,
  // otherwise /products/{handle}.js would leak the public price to guests.
  function showPrices() { var d = drawerEl(); return !!(d && d.dataset.wishlistShowPrices === 'true'); }
  // Guests have no cart in this theme — the header swaps the cart trigger for the
  // quote trigger, and cards render "Begär offert" instead of "Lägg i varukorg".
  // The drawer follows the same rule: add to cart under the hood, then hand over
  // to the offert drawer instead of the cart drawer.
  function quoteMode() { return !isLoggedIn(); }
  function ctaLabel() {
    return quoteMode() ? t('request_quote', 'Begär offert') : t('add_to_cart', 'Lägg i varukorg');
  }

  function savedProductIds() {
    var set = {};
    state.wishlist.lists.forEach(function (l) {
      (l.items || []).forEach(function (it) { set[String(it.product_id)] = true; });
    });
    return set;
  }
  function totalItems() {
    return state.wishlist.lists.reduce(function (n, l) { return n + ((l.items || []).length); }, 0);
  }
  function activeList() {
    if (state.active === '__shared__' && state.shared) return state.shared;
    return state.wishlist.lists.filter(function (l) { return l.id === state.active; })[0] ||
      state.wishlist.lists[0] || null;
  }

  function syncHearts() {
    var ids = savedProductIds();
    qsa('[data-wishlist-heart]').forEach(function (btn) {
      var on = !!ids[String(btn.dataset.productId)];
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (L.heart) { btn.setAttribute('aria-label', L.heart); btn.setAttribute('title', L.heart); }
    });
    qsa('[data-wishlist-count]').forEach(function (el) {
      var n = totalItems(); if (String(el.textContent) !== String(n)) el.textContent = n; el.hidden = n === 0;
    });
  }

  // ---- guest storage ----------------------------------------------------
  // Guests get the same drawer, but their lists live in localStorage instead of
  // the customer metafield. That is what makes a shared link work without login.
  var LS_GUEST = 'wubs_wishlist_guest';
  function isLoggedIn() { var d = drawerEl(); return !!(d && d.dataset.wishlistLoggedIn === 'true'); }
  function canShare() { var d = drawerEl(); return !!(d && d.dataset.wishlistCanShare === 'true'); }

  function guestRead() {
    try {
      var raw = localStorage.getItem(LS_GUEST);
      var w = raw ? JSON.parse(raw) : null;
      if (!w || typeof w !== 'object' || !Array.isArray(w.lists)) return { v: 1, lists: [] };
      return w;
    } catch (e) { return { v: 1, lists: [] }; }
  }
  function guestWrite(w) { try { localStorage.setItem(LS_GUEST, JSON.stringify(w)); } catch (e) {} }
  function guestId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'wl_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }
  function guestNow() { return new Date().toISOString(); }
  function guestClampQty(v, fb) { var n = parseInt(v, 10); if (!isFinite(n)) return fb; return Math.min(9999, Math.max(1, n)); }
  function guestSig(cfg) { try { return cfg ? JSON.stringify(cfg) : 'none'; } catch (e) { return 'none'; } }
  function guestNewList(name) { var ts = guestNow(); return { id: guestId(), name: name, created_at: ts, updated_at: ts, items: [] }; }
  function guestFindList(w, id) { return w.lists.filter(function (l) { return l.id === id; })[0] || null; }

  // Mirrors the server actions so the rest of the controller is storage-agnostic.
  function guestApi(action, p) {
    p = p || {};
    var w = guestRead();
    var extra = {};
    var list, item, idx;
    switch (action) {
      case 'get': break;
      case 'create_list': {
        if (!p.name) return Promise.reject(new Error(t('generic_error', 'Något gick fel')));
        list = guestNewList(String(p.name).slice(0, 120));
        w.lists.push(list); extra.list_id = list.id; break;
      }
      case 'rename_list': {
        list = guestFindList(w, p.list_id); if (!list) return Promise.reject(new Error('list_not_found'));
        list.name = String(p.name || '').slice(0, 120) || list.name; list.updated_at = guestNow(); break;
      }
      case 'delete_list': {
        w.lists = w.lists.filter(function (l) { return l.id !== p.list_id; }); break;
      }
      case 'add': {
        list = p.list_id ? guestFindList(w, p.list_id) : null;
        if (!list) {
          list = w.lists[0] || null;
          if (!list) { list = guestNewList(t('default_list_name', 'Min lista')); w.lists.push(list); }
        }
        var sig = guestSig(p.config || null);
        var match = list.items.filter(function (x) {
          return String(x.variant_id || '') === String(p.variant_id || '') && guestSig(x.config || null) === sig;
        })[0];
        if (match) { match.qty = guestClampQty(match.qty + guestClampQty(p.qty, 1), match.qty); extra.item_id = match.id; extra.deduped = true; }
        else {
          item = { id: guestId(), product_id: String(p.product_id || ''), variant_id: String(p.variant_id || ''),
            handle: String(p.handle || ''), qty: guestClampQty(p.qty, 1), added_at: guestNow(), config: p.config || null };
          list.items.push(item); extra.item_id = item.id;
        }
        extra.list_id = list.id; list.updated_at = guestNow(); break;
      }
      case 'remove': {
        list = guestFindList(w, p.list_id); if (!list) return Promise.reject(new Error('list_not_found'));
        list.items = list.items.filter(function (x) { return x.id !== p.item_id; }); list.updated_at = guestNow(); break;
      }
      case 'set_qty': {
        list = guestFindList(w, p.list_id); if (!list) return Promise.reject(new Error('list_not_found'));
        idx = list.items.map(function (x) { return x.id; }).indexOf(p.item_id);
        if (idx === -1) return Promise.reject(new Error('item_not_found'));
        if (Number(p.qty) <= 0) { list.items.splice(idx, 1); extra.removed = true; }
        else list.items[idx].qty = guestClampQty(p.qty, list.items[idx].qty);
        list.updated_at = guestNow(); break;
      }
      case 'clear': {
        list = guestFindList(w, p.list_id); if (list) { list.items = []; list.updated_at = guestNow(); } break;
      }
      default:
        return Promise.reject(new Error(t('generic_error', 'Något gick fel')));
    }
    w.v = 1;
    guestWrite(w);
    state.wishlist = w;
    return Promise.resolve(Object.assign({ ok: true, wishlist: w }, extra));
  }

  function api(action, params) {
    // get_shared is public and always server-side — that is how guests open a shared link.
    if (!isLoggedIn() && action !== 'get_shared') return guestApi(action, params);
    var body = Object.assign({ action: action }, params || {});
    return fetch(endpoint(), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (json) {
        if (!res.ok || !json || json.ok === false) {
          throw new Error((json && (json.message || json.error)) || ('Wishlist-fel ' + res.status));
        }
        if (json.wishlist && typeof json.wishlist === 'object') {
          state.wishlist = json.wishlist;
          if (!Array.isArray(state.wishlist.lists)) state.wishlist.lists = [];
        }
        return json;
      });
    });
  }

  function ensureActiveList() {
    var l = activeList();
    if (l) { state.active = l.id; return Promise.resolve(l.id); }
    return api('create_list', { name: t('default_list_name', 'Min lista') }).then(function (r) {
      state.active = r.list_id || (state.wishlist.lists[0] && state.wishlist.lists[0].id);
      if (state.active) localStorage.setItem(LS_ACTIVE, state.active);
      return state.active;
    });
  }

  // ---- heart toggle ----
  // Signature of a saved/selected configuration, so the heart can tell
  // "same product, different licences" apart from an exact duplicate.
  function wlConfigSig(cfg) {
    if (!cfg) return 'none';
    var b = cfg.bundle;
    var comps = (b && Array.isArray(b.components))
      ? b.components.map(function (c) { return String(c.variant_id || '') + 'x' + wlCompQty(c); }).sort().join(',')
      : '';
    return String(cfg.config_id || '') + '|' + comps;
  }

  function toggleHeart(btn) {
    if (state.busy) return;
    var pid = String(btn.dataset.productId);
    // Remember the rule for rows saved during this session.
    if (btn.dataset.neverShowPrice === 'true') noPriceIds[pid] = true;
    var sig = wlConfigSig(btn._wishlistConfig);
    var matches = [];
    state.wishlist.lists.forEach(function (l) {
      (l.items || []).forEach(function (it) {
        if (String(it.product_id) === pid) matches.push({ list_id: l.id, item_id: it.id, sig: wlConfigSig(it.config) });
      });
    });
    // Nothing configured → the heart plainly un-saves the product (as before).
    // Something configured → only an identical row un-saves; a new configuration
    // is saved as its own row, so re-saving with licences never deletes.
    var targets = (sig === 'none') ? matches : matches.filter(function (m) { return m.sig === sig; });
    var saved = targets.length > 0;
    state.busy = true; btn.classList.add('is-loading');

    var work;
    if (saved) {
      work = targets.reduce(function (p, r) { return p.then(function () { return api('remove', { list_id: r.list_id, item_id: r.item_id }); }); }, Promise.resolve());
    } else {
      work = ensureActiveList().then(function (listId) {
        return api('add', {
          list_id: listId,
          product_id: pid,
          variant_id: btn.dataset.variantId || '',
          handle: btn.dataset.handle || '',
          qty: 1,
          config: btn._wishlistConfig || null
        });
      });
    }

    work.then(function () {
      syncHearts();
      if (state.open) renderDrawer();
      if (!saved) openDrawer();
    }).catch(function (e) {
      console.error('[wishlist]', e); toast(e.message || t('generic_error', 'Något gick fel'));
    }).then(function () {
      state.busy = false; btn.classList.remove('is-loading');
    });
  }

  // ---- drawer ----
  function openDrawer() { var d = drawerEl(); if (!d) return; state.open = true; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; renderDrawer(); }
  function closeDrawer() { var d = drawerEl(); if (!d) return; state.open = false; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }

  function renderDrawer() {
    var d = drawerEl(); if (!d) return;
    var bar = qs('[data-wishlist-listbar]', d);
    var body = qs('[data-wishlist-body]', d);
    var addAll = qs('[data-wishlist-addall]', d);
    var lists = state.wishlist.lists;

    if (!lists.length && !state.shared) {
      bar.innerHTML = '';
      body.innerHTML = '<div class="wubs-wl-empty">' + esc(t('empty', 'Din inköpslista är tom.')) + '<br>' + esc(t('empty_hint', 'Klicka på hjärtat på en produkt för att spara den.')) + '</div>';
      if (addAll) addAll.hidden = true;
      return;
    }
    if (state.active !== '__shared__' && !activeList()) state.active = lists[0] ? lists[0].id : null;

    // tabs: shared preview first (if any), then the customer's own lists
    var tabs = '';
    if (state.shared) {
      tabs += '<button class="wubs-wl-tab wubs-wl-tab--shared' + (state.active === '__shared__' ? ' is-active' : '') +
        '" data-wishlist-tab="__shared__">' + esc(state.shared.name) + ' · ' + esc(t('shared_tab_suffix', 'delad')) + '</button>';
    }
    tabs += lists.map(function (l) {
      return '<button class="wubs-wl-tab' + (l.id === state.active ? ' is-active' : '') +
        '" data-wishlist-tab="' + esc(l.id) + '">' + esc(l.name) + ' (' + ((l.items || []).length) + ')</button>';
    }).join('');
    bar.innerHTML = tabs;

    // shared preview view (read-only + save CTA)
    if (state.active === '__shared__' && state.shared) {
      if (addAll) addAll.hidden = true;
      var sItems = state.shared.items || [];
      var cta = '<div class="wubs-wl-sharedbar">' +
        '<span class="wubs-wl-sharedbar__txt">' + esc(t('shared_banner', 'Någon har delat den här listan med dig.')) + '</span>' +
        '<button type="button" class="wubs-wl-sharedbar__save" data-wishlist-save-shared>' + esc(t('save_shared', 'Spara i mina inköpslistor')) + '</button>' +
        '</div>';
      body.innerHTML = cta + (sItems.length ? sItems.map(function (it) { return rowHtml(it, '__shared__', true); }).join('') :
        '<div class="wubs-wl-empty">' + esc(t('list_empty', 'Listan är tom.')) + '</div>');
      enrichAndRender();
      return;
    }

    var list = activeList();
    if (!list) { body.innerHTML = ''; if (addAll) addAll.hidden = true; return; }
    var items = (list && list.items) || [];
    if (addAll) addAll.hidden = items.length === 0;

    if (!items.length) {
      body.innerHTML = '<div class="wubs-wl-empty">' + esc(t('list_empty', 'Listan är tom.')) + '</div>' + listTools(list);
      return;
    }
    body.innerHTML = items.map(function (it) { return rowHtml(it, list.id); }).join('') + listTools(list);
    enrichAndRender();
  }

  function listTools(list) {
    return '<div class="wubs-wl-listtools">' +
      // Sharing requires an account — the token is stored server-side against the customer.
      (canShare() ? '<button data-wishlist-sharelist="' + esc(list.id) + '">' + esc(t('share', 'Dela')) + '</button>' : '') +
      '<button data-wishlist-renamelist="' + esc(list.id) + '">' + esc(t('rename', 'Byt namn')) + '</button>' +
      '<button data-wishlist-deletelist="' + esc(list.id) + '">' + esc(t('delete_list', 'Ta bort listan')) + '</button>' +
      '</div>';
  }

  // ---- product enrichment (title/image/price) via /products/{handle}.js ----
  var productCache = {};
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle] !== undefined) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { productCache[handle] = null; return null; });
  }
  function httpsUrl(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : (u || ''); }

  // ---- B2B pricing (same source/logic as wubs-sortiment-card: get-product-pricing) ----
  var pricingCtx = (function () { var el = qs('[data-wishlist-pricing]'); if (!el) return {}; try { return JSON.parse(el.textContent.trim()) || {}; } catch (e) { return {}; } })();
  // Guests have no pricing context (that block is logged-in only), so fall back
  // to the currency the drawer was rendered with.
  var WL_CURRENCY = pricingCtx.currency ||
    (function () { var d = drawerEl(); return (d && d.dataset.wishlistCurrency) || 'SEK'; })();
  function formatMoney(cents) {
    var amount = Number(cents || 0); if (!isFinite(amount)) amount = 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'sv-SE', {
        style: 'currency', currency: WL_CURRENCY,
        minimumFractionDigits: WL_CURRENCY === 'SEK' ? 0 : 2, maximumFractionDigits: WL_CURRENCY === 'SEK' ? 0 : 2
      }).format(amount / 100);
    } catch (e) { return Math.round(amount / 100).toLocaleString('sv-SE') + ' kr'; }
  }
  function nSpace(v) { return String(v || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }
  function nNum(v) { if (v === null || v === undefined || v === '') return null; if (typeof v === 'string') { var c = v.replace(/\s+/g, '').replace(',', '.'); var ps = Number(c); return isFinite(ps) ? ps : null; } var p = Number(v); return isFinite(p) ? p : null; }
  function moneyTextToCents(text) { var raw = nSpace(text); if (!raw) return 0; var m = raw.match(/-?\d[\d\s.,]*/g); if (!m || !m.length) return 0; var r = m[m.length - 1].replace(/[^\d,.\- ]/g, '').replace(/\s+/g, '').trim(); if (!r) return 0; var hc = r.indexOf(',') > -1, hd = r.indexOf('.') > -1, n = r; if (hc && hd) { n = r.lastIndexOf(',') > r.lastIndexOf('.') ? r.replace(/\./g, '').replace(',', '.') : r.replace(/,/g, ''); } else if (hc) { var cp = r.split(','); n = (cp.length === 2 && cp[1].length <= 2) ? r.replace(/\./g, '').replace(',', '.') : r.replace(/,/g, ''); } else if (hd) { var dp = r.split('.'); if (!(dp.length === 2 && dp[1].length <= 2)) n = r.replace(/\./g, ''); } var nv = Number(n); return isFinite(nv) ? Math.round(nv * 100) : 0; }
  function toCents(v, isCents) { if (v === null || v === undefined || v === '') return 0; if (typeof v === 'string' && /[a-zA-Z]|kr|SEK|,/.test(v)) return moneyTextToCents(v); var p = nNum(v); if (p === null) return 0; return isCents ? Math.round(p) : Math.round(p * 100); }
  function readCents(obj, keys) { if (!obj || !keys) return 0; for (var i = 0; i < keys.length; i++) { var k = keys[i]; if (Object.prototype.hasOwnProperty.call(obj, k) && obj[k] !== null && obj[k] !== undefined && obj[k] !== '') return toCents(obj[k], k.indexOf('_cents') > -1 || k.indexOf('Cents') > -1); } return 0; }
  function pxQty(v) { var p = parseInt(v, 10); return (isNaN(p) || p < 1) ? 1 : p; }
  function bestRule(rules) { if (!Array.isArray(rules) || !rules.length) return null; var b = rules.find(function (r) { return r && (r.best_match === true || r.current_match === true || r.final_match === true || r.selected === true); }); return b || rules[0]; }
  function volTier(tiers, qty) { if (!Array.isArray(tiers) || !tiers.length) return null; var d = tiers.find(function (t) { return t && (t.best_match === true || t.current_match === true || t.tier_match === true || t.selected === true); }); if (d) return d; var cq = pxQty(qty || 1); return tiers.find(function (t) { if (!t) return false; var f = nNum(t.from_qty), to = nNum(t.to_qty); if (f === null) f = 1; return cq >= f && (to === null || cq <= to); }) || null; }
  var PKEYS = ['final_unit_price_cents', 'unit_price_cents', 'price_cents', 'final_price_cents', 'discounted_price_cents', 'calculated_price_cents', 'final_unit_price', 'unit_price', 'price', 'final_price', 'discounted_price', 'calculated_price'];
  var CKEYS = ['unit_compare_price_cents', 'compare_at_price_cents', 'compare_price_cents', 'original_price_cents', 'unit_compare_price', 'compare_at_price', 'compare_price', 'original_price'];
  function directCand(data, base) { if (!data) return null; var dp = readCents(data, PKEYS); if (dp <= 0) return null; return { price: dp, compare: readCents(data, CKEYS) || base, source: 'direct' }; }
  function applyDiscount(base, item) { if (!item || !base || base <= 0) return null; var ep = readCents(item, PKEYS); if (ep > 0) return { price: ep, compare: readCents(item, CKEYS) || base, source: 'explicit' }; var type = nSpace(item.discount_type || item.type || item.discount_method || item.method).toLowerCase(); var rv = item.discount_value; if (rv === null || rv === undefined || rv === '') rv = item.value; var val = nNum(rv); if (val === null) return null; if (type.indexOf('percent') > -1 || type === '%' || type === 'pct') return { price: Math.max(0, Math.round(base * ((100 - val) / 100))), compare: base, source: 'percent' }; if (type.indexOf('fixed') > -1 || type.indexOf('amount') > -1 || type.indexOf('money') > -1) return { price: Math.max(0, Math.round(base - toCents(val, false))), compare: base, source: 'fixed' }; if (type.indexOf('price') > -1) return { price: Math.max(0, toCents(val, false)), compare: base, source: 'price' }; if (val === 0) return { price: base, compare: base, source: 'zero' }; if (val > 0 && val <= 100) return { price: Math.max(0, Math.round(base * ((100 - val) / 100))), compare: base, source: 'assumed_percent' }; return null; }
  function resolveRemotePrice(data, base, qty) { if (!data || data.ok !== true || data.has_pricing !== true) return null; var c = []; var dc = directCand(data, base); if (dc && dc.price > 0) c.push(dc); if (data.wholesale && data.wholesale.matched && Array.isArray(data.wholesale.rules)) { var wc = applyDiscount(base, bestRule(data.wholesale.rules)); if (wc && wc.price > 0) { wc.source = 'wholesale'; c.push(wc); } } if (data.volume && data.volume.matched && Array.isArray(data.volume.tiers)) { var vc = applyDiscount(base, volTier(data.volume.tiers, qty)); if (vc && vc.price > 0) { vc.source = 'volume'; c.push(vc); } } if (!c.length) return null; c.sort(function (a, b) { return Number(a.price || 0) - Number(b.price || 0); }); var best = c[0]; if (!best || best.price <= 0) return null; if (!best.compare || best.compare < best.price) best.compare = base > best.price ? base : best.price; return best; }
  function fetchB2BPrice(it) {
    if (!pricingCtx.endpoint || !it._productId || !it.variant_id) return Promise.resolve();
    var qty = parseInt(it.qty, 10) || 1;
    var payload = { product_id: String(it._productId), variant_id: String(it.variant_id), product_tags: it._tags || [], collection_ids: [], customer_tags: pricingCtx.customer_tags || [], customer_id: pricingCtx.customer_id || null, is_logged_in: pricingCtx.is_logged_in === true, market: pricingCtx.market || '', quantity: qty };
    var headers = { 'Content-Type': 'application/json' };
    if (pricingCtx.anon_key) { headers.apikey = pricingCtx.anon_key; headers.Authorization = 'Bearer ' + pricingCtx.anon_key; }
    return fetch(pricingCtx.endpoint, { method: 'POST', headers: headers, body: JSON.stringify(payload) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var res = resolveRemotePrice(data, Number(it._basePrice || 0), qty);
        if (res && res.price > 0) { it._price = res.price; it._compare = (res.compare && res.compare > res.price) ? res.compare : null; it._priceSource = res.source; }
      })
      .catch(function () {});
  }
  // Fetch missing product data for all items, then re-render once.
  function enrichAndRender() {
    var pending = [];
    var collect = function (items) { (items || []).forEach(function (it) { if (it.handle && !it._enriched) pending.push(it); }); };
    state.wishlist.lists.forEach(function (l) { collect(l.items); });
    if (state.shared) collect(state.shared.items);
    if (!pending.length) return;
    var handles = {};
    pending.forEach(function (it) { handles[it.handle] = 1; });
    Promise.all(Object.keys(handles).map(fetchProduct)).then(function () {
      // base enrichment from products.js
      pending.forEach(function (it) {
        var p = productCache[it.handle];
        if (!p) { it._enriched = true; return; }
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(it.variant_id); })[0];
        it._title = p.title;
        it._variant_title = v ? v.title : '';
        it._basePrice = v ? v.price : p.price;
        it._price = it._basePrice;
        it._compare = (v && v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : null;
        it._productId = p.id;
        it._tags = p.tags || [];
        it._image = (v && v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
      });
      // resolve the customer's B2B price per item (same as the product card), then re-render
      var jobs = pending.map(function (it) {
        if (!productCache[it.handle]) return Promise.resolve();
        // No point resolving a B2B price we will never render.
        if (hidesPrice(it)) { it._enriched = true; return Promise.resolve(); }
        return fetchB2BPrice(it).then(function () { it._enriched = true; });
      });
      // …and for every bundle component, so licences/tillval show the customer's price too.
      pending.forEach(function (it) {
        wlComponents(it).forEach(function (c) {
          if (!c || c._pricedone) return;
          c._pricedone = true;
          c._productId = c.product_id || '';
          c._basePrice = toCents(c.compare_at_price, false) || toCents(c.price, false);
          c._tags = c._tags || [];
          c.qty = wlCompQty(c);
          jobs.push(fetchB2BPrice(c));
        });
      });
      return Promise.all(jobs);
    }).then(function () {
      if (state.open) renderDrawer();
    });
  }

  // Visible line item properties — same rules as cart drawer (skip _-keys, uploads → link).
  function wlBuildProps(props) {
    props = props || {};
    var html = '';
    Object.keys(props).forEach(function (key) {
      if (!key || String(key).charAt(0) === '_') return;
      var value = props[key];
      if (value === undefined || value === null || value === '') return;
      if (typeof value === 'object') { try { value = JSON.stringify(value); } catch (e) { value = String(value || ''); } }
      value = String(value || '').trim();
      if (!value) return;
      var valueHtml;
      if (value.indexOf('/uploads/') > -1) { var fn = value.split('/').pop() || value; valueHtml = '<a href="' + esc(value) + '" target="_blank" rel="noopener">' + esc(fn) + '</a>'; }
      else valueHtml = esc(value);
      html += '<div class="wubs-wl-row__prop"><span class="wubs-wl-row__propName">' + esc(key) + ':</span><span class="wubs-wl-row__propValue">' + valueHtml + '</span></div>';
    });
    return html ? '<div class="wubs-wl-row__props">' + html + '</div>' : '';
  }

  // ---- bundles (parent + addon/licence components), mirroring the cart drawer ----
  function wlComponents(it) {
    var b = it && it.config && it.config.bundle;
    return (b && Array.isArray(b.components)) ? b.components : [];
  }
  function wlCompQty(c) { var q = parseInt(c && (c.qty != null ? c.qty : c.quantity), 10); return (!q || q < 1) ? 1 : q; }
  // Unit price in cents for a component — resolved B2B price wins, saved price is the fallback.
  function wlCompUnitCents(c) {
    if (c._price != null && isFinite(c._price)) return Number(c._price);
    return toCents(c.price, false);
  }
  function wlCompCompareCents(c) {
    if (c._compare != null && isFinite(c._compare)) return Number(c._compare);
    return toCents(c.compare_at_price, false);
  }
  // Group total = parent + every component, exactly like recalculateDisplayRowTotals.
  function wlRowTotals(it, qty) {
    var unit = Number(it._price || 0) || 0;
    var comp = Number(it._compare || 0) || unit;
    wlComponents(it).forEach(function (c) {
      var cq = wlCompQty(c);
      unit += wlCompUnitCents(c) * cq;
      comp += (wlCompCompareCents(c) || wlCompUnitCents(c)) * cq;
    });
    return { final: unit * qty, original: comp * qty };
  }
  function wlComponentsHtml(it, qty) {
    var comps = wlComponents(it);
    if (!comps.length) return '';
    var html = '<div class="wubs-wl-row__components">';
    comps.forEach(function (c) {
      var cq = wlCompQty(c);
      var cur = wlCompUnitCents(c) * cq * qty;
      var cmp = (wlCompCompareCents(c) || 0) * cq * qty;
      if (cmp < cur) cmp = cur;
      var title = c.title || c._title || c.sku || t('addon_default', 'Tillval');
      if (cq > 1) title += ' ×' + cq;
      html += '<div class="wubs-wl-row__component">' +
          '<div class="wubs-wl-row__componentMain">' +
            '<div class="wubs-wl-row__componentName">' + esc(title) + '</div>' +
            (c.properties ? wlBuildProps(c.properties) : '') +
          '</div>' +
          (showPrices()
            ? '<div class="wubs-wl-row__componentPrices">' +
                (cmp > cur ? '<span class="wubs-wl-row__componentCompare">' + esc(formatMoney(cmp)) + '</span>' : '') +
                '<span class="wubs-wl-row__componentPrice">' + esc(formatMoney(cur)) + '</span>' +
              '</div>'
            : '') +
        '</div>';
    });
    return html + '</div>';
  }

  // Render the saved configuration for a wishlist item — visible line item
  // properties first, otherwise the raw selections (so the dropdown always shows something).
  function wlConfigDetails(config) {
    if (!config || typeof config !== 'object') return '';
    var html = config.line_item_properties ? wlBuildProps(config.line_item_properties) : '';
    if (html) return html;
    var sel = config.selections;
    if (sel && typeof sel === 'object') {
      var rows = '';
      Object.keys(sel).forEach(function (k) {
        if (!k || String(k).charAt(0) === '_') return;
        var v = sel[k];
        if (v === undefined || v === null || v === '') return;
        if (typeof v === 'object') { try { v = JSON.stringify(v); } catch (e) { v = String(v || ''); } }
        v = String(v || '').trim(); if (!v) return;
        rows += '<div class="wubs-wl-row__prop"><span class="wubs-wl-row__propName">' + esc(k) + ':</span><span class="wubs-wl-row__propValue">' + esc(v) + '</span></div>';
      });
      if (rows) return '<div class="wubs-wl-row__props">' + rows + '</div>';
    }
    return '';
  }

  function rowHtml(it, listId, readOnly) {
    // Never fall back to the handle — it would flash the raw slug until
    // /products/{handle}.js resolves. Show a skeleton placeholder instead.
    var title = it._title || it.title || '';
    var titleHtml = title
      ? esc(title)
      : '<span class="wubs-wl-row__titleSkeleton" aria-hidden="true"></span><span class="wubs-wl-visually-hidden">' + esc(t('loading', 'Hämtar…')) + '</span>';
    var imgSrc = httpsUrl(it._image);
    var img = imgSrc ? '<img class="wubs-wl-row__img" src="' + esc(imgSrc) + '" alt="" loading="lazy">' :
      '<span class="wubs-wl-row__img"></span>';
    var url = it.handle ? '/products/' + esc(it.handle) : '#';
    var qty = parseInt(it.qty, 10) || 1;
    var cfgDetails = it.config ? wlConfigDetails(it.config) : '';
    var meta = [];
    if (it._variant_title && it._variant_title !== 'Default Title') meta.push('<span class="wubs-wl-row__variant">' + esc(it._variant_title) + '</span>');
    if (showPrices() && it._price != null && it._price !== '' && !hidesPrice(it)) {
      // Group price: parent + components, like the cart drawer.
      var tot = wlRowTotals(it, qty);
      var priceHtml = '<span class="wubs-wl-row__price">' + esc(formatMoney(tot.final)) + '</span>';
      if (tot.original > tot.final) priceHtml += '<span class="wubs-wl-row__compare">' + esc(formatMoney(tot.original)) + '</span>';
      meta.push(priceHtml);
    }
    if (readOnly) meta.push('<span class="wubs-wl-row__variant">' + esc(t('qty_prefix', 'Antal: ')) + qty + '</span>');
    if (it.config && cfgDetails) {
      meta.push('<button type="button" class="wubs-wl-row__config" data-wishlist-config-toggle aria-expanded="false">' +
        esc(t('configured', 'Konfigurerad')) +
        '<svg class="wubs-wl-row__configcaret" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>');
    } else if (it.config && !wlComponents(it).length) {
      // Only when there is nothing else to show — the component list IS the configuration.
      meta.push('<span class="wubs-wl-row__config wubs-wl-row__config--static">' + esc(t('configured', 'Konfigurerad')) + '</span>');
    }
    var controls = readOnly
      ? '<button class="wubs-wl-row__add" data-wishlist-tocart="' + esc(it.id) + '" data-list="' + esc(listId) + '">' + esc(ctaLabel()) + '</button>'
      : '<span class="wubs-wl-qty">' +
          '<button type="button" data-wishlist-qty="-1" data-list="' + esc(listId) + '" data-item="' + esc(it.id) + '" aria-label="' + esc(t('decrease', 'Minska')) + '">−</button>' +
          '<input type="text" value="' + qty + '" readonly aria-label="' + esc(t('qty', 'Antal')) + '">' +
          '<button type="button" data-wishlist-qty="1" data-list="' + esc(listId) + '" data-item="' + esc(it.id) + '" aria-label="' + esc(t('increase', 'Öka')) + '">+</button>' +
        '</span>' +
        '<button class="wubs-wl-row__add" data-wishlist-tocart="' + esc(it.id) + '" data-list="' + esc(listId) + '">' + esc(ctaLabel()) + '</button>';
    var removeBtn = readOnly ? '' :
      '<button class="wubs-wl-row__remove" data-wishlist-removeitem="' + esc(it.id) + '" data-list="' + esc(listId) + '" aria-label="' + esc(t('remove', 'Ta bort')) + '" title="' + esc(t('remove', 'Ta bort')) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    return '' +
      '<div class="wubs-wl-row" data-wishlist-item="' + esc(it.id) + '">' +
        img +
        '<div class="wubs-wl-row__info">' +
          '<a class="wubs-wl-row__title" href="' + url + '">' + titleHtml + '</a>' +
          '<div class="wubs-wl-row__meta">' + meta.join('') + '</div>' +
          wlComponentsHtml(it, qty) +
          (it.config && cfgDetails ? '<div class="wubs-wl-row__configpanel" data-wishlist-config-panel hidden>' + cfgDetails + '</div>' : '') +
          '<div class="wubs-wl-row__controls">' + controls + '</div>' +
        '</div>' +
        removeBtn +
      '</div>';
  }

  function findItem(listId, itemId) {
    if (listId === '__shared__' && state.shared) return (state.shared.items || []).filter(function (x) { return x.id === itemId; })[0] || null;
    var l = state.wishlist.lists.filter(function (x) { return x.id === listId; })[0];
    if (!l) return null;
    return (l.items || []).filter(function (x) { return x.id === itemId; })[0] || null;
  }

  // ---- add to cart (with config + bundle replay) ----
  // Ported from the buybox so the cart drawer groups and prices these lines
  // exactly as if they had been added from the product page.
  function wlNewBundleId() {
    return 'wubs_bundle_' + String(Date.now()) + '_' + Math.random().toString(36).slice(2, 10);
  }
  function wlApplyBundleProps(properties, bundle) {
    if (!properties || !bundle || !bundle.bundleId) return properties;
    properties._bundle_id = String(bundle.bundleId);
    properties._bundle_role = String(bundle.role || '');
    properties._bundle_title = String(bundle.title || '');
    properties._bundle_parent_variant_id = String(bundle.parentVariantId || '');
    properties._bundle_parent_sku = String(bundle.parentSku || '');
    properties._wubs_bundle_id = String(bundle.bundleId);
    properties._wubs_bundle_role = String(bundle.role || '');
    properties._wubs_bundle_title = String(bundle.title || '');
    if (bundle.parentProductId) properties._bundle_parent_product_id = String(bundle.parentProductId);
    if (bundle.componentTitle) properties._bundle_component_title = String(bundle.componentTitle);
    if (bundle.componentSku) properties._bundle_component_sku = String(bundle.componentSku);
    if (bundle.componentQtyPerParent != null) properties._bundle_component_qty_per_parent = String(bundle.componentQtyPerParent);
    if (bundle.componentIndex != null) properties._bundle_component_index = String(bundle.componentIndex);
    return properties;
  }
  function wlAssign(target, src) {
    if (src) Object.keys(src).forEach(function (k) { target[k] = src[k]; });
    return target;
  }

  function addToCart(item) {
    var vid = Number(item.variant_id);
    if (!vid) return Promise.reject(new Error(t('add_cart_error', 'Kunde inte lägga i varukorgen')));
    var qty = parseInt(item.qty, 10) || 1;
    var props = (item.config && item.config.line_item_properties) || {};
    var bundle = item.config && item.config.bundle;
    var comps = (bundle && Array.isArray(bundle.components)) ? bundle.components : [];
    var payload;

    if (comps.length) {
      var bundleId = wlNewBundleId();
      var pVariant = String((bundle.parent && bundle.parent.variant_id) || item.variant_id);
      var pProduct = String((bundle.parent && bundle.parent.product_id) || item.product_id || '');
      var pSku = String((bundle.parent && bundle.parent.sku) || '');
      var bTitle = String(bundle.title || item._title || '');
      var parentProps = wlAssign(wlAssign({}, (bundle.parent && bundle.parent.properties) || {}), props);
      wlApplyBundleProps(parentProps, {
        bundleId: bundleId, role: 'parent', title: bTitle,
        parentVariantId: pVariant, parentProductId: pProduct, parentSku: pSku
      });
      parentProps._bundle_component_count = String(comps.length);
      parentProps._wubs_bundle_component_count = String(comps.length);

      var items = [{ id: Number(pVariant) || vid, quantity: qty, properties: parentProps }];
      comps.forEach(function (c, i) {
        var cvid = Number(c.variant_id || c.id);
        if (!cvid) return;
        var cq = wlCompQty(c);
        var cp = wlAssign({}, c.properties || {});
        wlApplyBundleProps(cp, {
          bundleId: bundleId, role: c.is_warranty ? 'warranty' : 'component', title: bTitle,
          parentVariantId: pVariant, parentProductId: pProduct, parentSku: pSku,
          componentTitle: c.title || '', componentSku: c.sku || '',
          componentQtyPerParent: cq, componentIndex: i + 1
        });
        // The cart drawer prices components from these keys — without them they render as 0.
        var unit = wlCompUnitCents(c);
        var cmp = wlCompCompareCents(c) || unit;
        cp._wubs_expected_unit_price_cents = String(unit);
        cp._wubs_expected_compare_at_price_cents = String(cmp);
        cp._wubs_expected_line_price_cents = String(unit * cq * qty);
        if (c.price_mode) cp._wubs_component_price_mode = String(c.price_mode);
        items.push({ id: cvid, quantity: Math.max(1, qty * cq), properties: cp });
      });
      payload = { items: items };
    } else {
      payload = { id: vid, quantity: qty };
      if (props && Object.keys(props).length) payload.properties = props;
    }

    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (j) { throw new Error((j && (j.description || j.message)) || t('add_cart_error', 'Kunde inte lägga i varukorgen')); });
      return res.json();
    }).then(function () {
      // Tell the theme's header to refresh its cart badge (it listens to wubs:cart-updated).
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = (cart && cart.item_count) || 0;
          document.dispatchEvent(new CustomEvent('wubs:cart-updated', { detail: { item_count: count } }));
        })
        .catch(function () {});
    });
  }

  // After adding to cart we hand over to the cart drawer: close this one,
  // then open the cart (it refreshes itself on open).
  function handOverToCart() {
    closeDrawer();
    var wantsQuote = quoteMode();
    setTimeout(function () {
      try {
        if (wantsQuote) {
          if (typeof window.openWubsOffertDrawer === 'function') { window.openWubsOffertDrawer(); return; }
          if (window.wubsOffertDrawerOpen && typeof window.wubsOffertDrawerOpen.wubs === 'function') { window.wubsOffertDrawerOpen.wubs(); return; }
          document.dispatchEvent(new CustomEvent('wubs:offert-drawer:open'));
          return;
        }
        if (typeof window.openWubsCartDrawer === 'function') { window.openWubsCartDrawer(); return; }
        if (typeof window.wubsCartDrawerOpenDefault === 'function') { window.wubsCartDrawerOpenDefault(); return; }
        if (window.wubsCartDrawerOpen && typeof window.wubsCartDrawerOpen.wubs === 'function') { window.wubsCartDrawerOpen.wubs(); return; }
        document.dispatchEvent(new CustomEvent('wubs:cart-open-any'));
      } catch (e) {
        try {
          document.dispatchEvent(new CustomEvent(wantsQuote ? 'wubs:offert-drawer:open' : 'wubs:cart-open-any'));
        } catch (e2) {}
      }
    }, 240);
  }

  // ---- toast ----
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'wubs-wl-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  // ---- themed dialog (replaces window.prompt / window.confirm) ----
  function anyModalOpen() { return !!(drawerEl() && drawerEl().querySelector('.wubs-wl-modal')); }
  function wubsDialog(opts) {
    return new Promise(function (resolve) {
      var panel = drawerEl() && drawerEl().querySelector('.wubs-wl-drawer__panel');
      if (!panel) { resolve(opts.input ? window.prompt(opts.title || '', opts.value || '') : window.confirm(opts.title || '')); return; }
      var wrap = document.createElement('div');
      wrap.className = 'wubs-wl-modal';
      var inputHtml = opts.input ? '<input class="wubs-wl-modal__input" type="text" value="' + esc(opts.value || '') + '" placeholder="' + esc(opts.placeholder || '') + '"' + (opts.readonly ? ' readonly' : '') + '>' : '';
      var msgHtml = opts.message ? '<p class="wubs-wl-modal__msg">' + esc(opts.message) + '</p>' : '';
      wrap.innerHTML = '<div class="wubs-wl-modal__card" role="dialog" aria-modal="true">' +
        '<p class="wubs-wl-modal__title">' + esc(opts.title || '') + '</p>' + msgHtml + inputHtml +
        '<div class="wubs-wl-modal__actions">' +
          '<button type="button" class="wubs-wl-modal__btn wubs-wl-modal__btn--ghost" data-wl-cancel>' + esc(t('cancel', 'Avbryt')) + '</button>' +
          '<button type="button" class="wubs-wl-modal__btn' + (opts.danger ? ' wubs-wl-modal__btn--danger' : '') + '" data-wl-ok>' + esc(opts.okLabel || t('ok', 'OK')) + '</button>' +
        '</div></div>';
      panel.appendChild(wrap);
      requestAnimationFrame(function () { wrap.classList.add('is-open'); });
      var input = wrap.querySelector('.wubs-wl-modal__input');
      if (input) { input.focus(); input.select(); }
      else { var okb = wrap.querySelector('[data-wl-ok]'); if (okb) okb.focus(); }
      var settled = false;
      function done(val) { if (settled) return; settled = true; wrap.classList.remove('is-open'); setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 180); resolve(val); }
      wrap.addEventListener('click', function (e) {
        if (e.target === wrap || e.target.closest('[data-wl-cancel]')) { done(opts.input ? null : false); return; }
        if (e.target.closest('[data-wl-ok]')) { done(opts.input ? (input ? input.value.trim() : '') : true); return; }
      });
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && opts.input) { e.preventDefault(); done(input ? input.value.trim() : ''); }
        else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); done(opts.input ? null : false); }
      });
    });
  }

  // ---- delegated events ----
  function onClick(e) {
    var heart = e.target.closest && e.target.closest('[data-wishlist-heart]');
    if (heart) { e.preventDefault(); toggleHeart(heart); return; }

    var trigger = e.target.closest && e.target.closest('[data-wishlist-open]');
    if (trigger) {
      e.preventDefault(); e.stopPropagation();
      var dd = drawerEl();
      if (dd && dd.classList.contains('is-open')) closeDrawer(); else openDrawer();
      return;
    }

    if (!drawerEl()) return;
    var tgt = e.target;
    if (tgt.closest('[data-wishlist-close]')) { closeDrawer(); return; }

    var cfgToggle = tgt.closest('[data-wishlist-config-toggle]');
    if (cfgToggle) {
      e.preventDefault();
      var row = cfgToggle.closest('.wubs-wl-row');
      var panel = row && row.querySelector('[data-wishlist-config-panel]');
      if (panel) {
        var willOpen = panel.hasAttribute('hidden');
        if (willOpen) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
        cfgToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        cfgToggle.classList.toggle('is-open', willOpen);
      }
      return;
    }

    var tab = tgt.closest('[data-wishlist-tab]');
    if (tab) { state.active = tab.getAttribute('data-wishlist-tab'); if (state.active !== '__shared__') { try { localStorage.setItem(LS_ACTIVE, state.active); } catch (e) {} } renderDrawer(); return; }

    var saveShared = tgt.closest('[data-wishlist-save-shared]');
    if (saveShared) {
      if (!state.shared) return;
      saveShared.disabled = true; saveShared.textContent = t('saving', 'Sparar…');
      var sharedItems = state.shared.items || [];
      var newId = null;
      api('create_list', { name: state.shared.name || t('shared_default_name', 'Delad lista') }).then(function (r) {
        newId = r.list_id;
        return sharedItems.reduce(function (p, sit) {
          return p.then(function () { return api('add', { list_id: newId, product_id: sit.product_id, variant_id: sit.variant_id, handle: sit.handle, qty: sit.qty, config: sit.config }); });
        }, Promise.resolve());
      }).then(function () {
        state.shared = null;
        if (newId) { state.active = newId; try { localStorage.setItem(LS_ACTIVE, newId); } catch (e) {} }
        syncHearts(); renderDrawer(); toast(t('saved_to_lists', 'Sparad i dina inköpslistor'));
      }).catch(function (er) { saveShared.disabled = false; saveShared.textContent = t('save_shared', 'Spara i mina inköpslistor'); toast(er.message); });
      return;
    }

    var qbtn = tgt.closest('[data-wishlist-qty]');
    if (qbtn) {
      var it = findItem(qbtn.getAttribute('data-list'), qbtn.getAttribute('data-item'));
      if (!it) return;
      var next = (parseInt(it.qty, 10) || 1) + parseInt(qbtn.getAttribute('data-wishlist-qty'), 10);
      if (next < 1) next = 1;
      api('set_qty', { list_id: qbtn.getAttribute('data-list'), item_id: qbtn.getAttribute('data-item'), qty: next })
        .then(function () { renderDrawer(); syncHearts(); }).catch(function (er) { toast(er.message); });
      return;
    }

    var rm = tgt.closest('[data-wishlist-removeitem]');
    if (rm) {
      api('remove', { list_id: rm.getAttribute('data-list'), item_id: rm.getAttribute('data-wishlist-removeitem') })
        .then(function () { renderDrawer(); syncHearts(); }).catch(function (er) { toast(er.message); });
      return;
    }

    var tc = tgt.closest('[data-wishlist-tocart]');
    if (tc) {
      var item = findItem(tc.getAttribute('data-list'), tc.getAttribute('data-wishlist-tocart'));
      if (!item) return;
      tc.disabled = true;
      addToCart(item).then(function () {
        toast(quoteMode() ? t('added_to_quote', 'Tillagd i offerten') : t('added_to_cart', 'Tillagd i varukorgen'));
        handOverToCart();
      })
        .catch(function (er) { toast(er.message); })
        .then(function () { tc.disabled = false; });
      return;
    }

    var addAll = tgt.closest('[data-wishlist-addall]');
    if (addAll) {
      var list = activeList(); if (!list) return;
      addAll.disabled = true;
      (list.items || []).reduce(function (p, it2) { return p.then(function () { return addToCart(it2); }); }, Promise.resolve())
        .then(function () {
          toast(quoteMode() ? t('list_added_to_quote', 'Listan tillagd i offerten') : t('list_added_to_cart', 'Listan tillagd i varukorgen'));
          handOverToCart();
        })
        .catch(function (er) { toast(er.message); })
        .then(function () { addAll.disabled = false; });
      return;
    }

    var nl = tgt.closest('[data-wishlist-newlist]');
    if (nl) {
      wubsDialog({ title: t('new_list_title', 'Ny inköpslista'), input: true, placeholder: t('new_list_placeholder', 'Namn på listan'), okLabel: t('create', 'Skapa') }).then(function (name) {
        if (!name) return;
        api('create_list', { name: name }).then(function (r) {
          if (r.list_id) { state.active = r.list_id; localStorage.setItem(LS_ACTIVE, r.list_id); }
          renderDrawer();
        }).catch(function (er) { toast(er.message); });
      });
      return;
    }

    var rn = tgt.closest('[data-wishlist-renamelist]');
    if (rn) {
      var lid = rn.getAttribute('data-wishlist-renamelist');
      var cur = state.wishlist.lists.filter(function (x) { return x.id === lid; })[0];
      wubsDialog({ title: t('rename_title', 'Byt namn på listan'), input: true, value: (cur && cur.name) || '', okLabel: t('save', 'Spara') }).then(function (nm) {
        if (!nm) return;
        api('rename_list', { list_id: lid, name: nm }).then(renderDrawer).catch(function (er) { toast(er.message); });
      });
      return;
    }

    var sh = tgt.closest('[data-wishlist-sharelist]');
    if (sh) {
      var slid = sh.getAttribute('data-wishlist-sharelist');
      api('create_share', { list_id: slid }).then(function (r) {
        // The link opens the drawer anywhere on the site — no dedicated page.
        var url = window.location.origin + '/?wl=' + encodeURIComponent(r.token || '');
        wubsDialog({ title: t('share_title', 'Dela listan'), message: t('share_msg', 'Vem som helst med länken kan se listan och lägga produkterna i sin varukorg.'), input: true, value: url, readonly: true, okLabel: t('copy_link', 'Kopiera länk') }).then(function (v) {
          if (v == null) return;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function () { toast(t('link_copied', 'Länk kopierad')); }, function () { toast(t('copy_manual', 'Kopiera länken manuellt')); });
          } else { toast(t('copy_manual', 'Kopiera länken manuellt')); }
        });
      }).catch(function (er) { toast(er.message); });
      return;
    }

    var dl = tgt.closest('[data-wishlist-deletelist]');
    if (dl) {
      var dlid = dl.getAttribute('data-wishlist-deletelist');
      wubsDialog({ title: t('delete_title', 'Ta bort listan?'), message: t('delete_msg', 'Listan och alla sparade produkter i den tas bort.'), okLabel: t('delete_ok', 'Ta bort'), danger: true }).then(function (ok) {
        if (!ok) return;
        api('delete_list', { list_id: dlid })
          .then(function () { state.active = (state.wishlist.lists[0] && state.wishlist.lists[0].id) || null; renderDrawer(); syncHearts(); })
          .catch(function (er) { toast(er.message); });
      });
      return;
    }
  }

  function applyStaticLabels() {
    var d = drawerEl(); if (!d) return;
    var setTxt = function (sel, key) { var e = qs(sel, d); if (e && L[key]) e.textContent = L[key]; };
    setTxt('.wubs-wl-drawer__title', 'title');
    var closeB = qs('.wubs-wl-drawer__close', d); if (closeB && L.close) closeB.setAttribute('aria-label', L.close);
    setTxt('[data-wishlist-newlist]', 'new_list');
    setTxt('[data-wishlist-addall]', quoteMode() ? 'request_quote_all' : 'add_all');
  }

  function init() {
    loadInitial();
    // Portal: move the drawer to <body> so position:fixed is relative to the
    // viewport and not a transformed ancestor (the header section uses transforms).
    var d = drawerEl();
    if (d && d.parentNode !== document.body) document.body.appendChild(d);
    applyStaticLabels();
    syncHearts();
    // Re-sync hearts when new ones enter the DOM (AJAX pagination / lazy content).
    // Scoped to added hearts so the drawer's own re-renders can't loop this.
    if (window.MutationObserver) {
      var moPending = false;
      var mo = new MutationObserver(function (muts) {
        var hit = false;
        for (var i = 0; i < muts.length && !hit; i++) {
          var an = muts[i].addedNodes || [];
          for (var j = 0; j < an.length; j++) {
            var nd = an[j];
            if (nd.nodeType === 1 && ((nd.matches && nd.matches('[data-wishlist-heart]')) || (nd.querySelector && nd.querySelector('[data-wishlist-heart]')))) { hit = true; break; }
          }
        }
        if (hit && !moPending) { moPending = true; requestAnimationFrame(function () { moPending = false; syncHearts(); }); }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    // Capture phase so we run before the header's own click handling, which
    // stops propagation on its tool buttons (would otherwise swallow the trigger).
    document.addEventListener('click', onClick, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open && !anyModalOpen()) closeDrawer(); });
    // let product forms attach configured-product data to a heart before it is clicked:
    // set heartButton._wishlistConfig = { form_id, config_id, selections, line_item_properties }
    window.WubsWishlist = {
      open: openDrawer,
      refresh: function () { syncHearts(); if (state.open) renderDrawer(); },
      // Reload lists from the server, then open the drawer (optionally on a specific list).
      reloadAndOpen: function (listId) {
        return api('get').then(function () {
          syncHearts();
          if (listId) { state.active = listId; try { localStorage.setItem(LS_ACTIVE, listId); } catch (e) {} }
          openDrawer();
        }).catch(function () { openDrawer(); });
      },
      openList: function (listId) {
        if (listId) { state.active = listId; try { localStorage.setItem(LS_ACTIVE, listId); } catch (e) {} }
        openDrawer();
      },
      // Resolve the viewer's own B2B prices for arbitrary variants.
      // Used by the public shared-list page so it shows the same prices as the drawer.
      // entries: [{product_id, variant_id, tags, basePrice, qty}] → [{price, compare}]
      resolvePrices: function (entries) {
        if (!Array.isArray(entries) || !pricingCtx.endpoint) return Promise.resolve([]);
        return Promise.all(entries.map(function (e) {
          var tmp = {
            _productId: String(e.product_id || ''),
            variant_id: String(e.variant_id || ''),
            _tags: e.tags || [],
            _basePrice: Number(e.basePrice || 0),
            qty: parseInt(e.qty, 10) || 1
          };
          return fetchB2BPrice(tmp).then(function () {
            return { price: tmp._price != null ? tmp._price : null, compare: tmp._compare != null ? tmp._compare : null };
          });
        }));
      },
      // Show a received/shared list as a read-only preview tab in the drawer.
      showShared: function (list) {
        if (!list) return;
        state.shared = {
          id: '__shared__',
          name: list.name || t('shared_default_name', 'Delad lista'),
          items: (list.items || []).map(function (it) {
            // get_shared reports the "never show price" rule per row — the
            // viewer has no other way to know it (guests included).
            if (it.never_show_price === true && it.product_id) noPriceIds[String(it.product_id)] = true;
            return { id: it.id, product_id: it.product_id, variant_id: it.variant_id, handle: it.handle, qty: it.qty, config: it.config };
          })
        };
        state.active = '__shared__';
        openDrawer();
      },
      state: state
    };

    openSharedFromUrl();
  }

  // A shared link is just ?wl=<token> on any page — works for guests too, since
  // get_shared is public and guest lists live in localStorage.
  function openSharedFromUrl() {
    var m = /[?&]wl=([^&#]+)/.exec(window.location.search);
    if (!m) return;
    var token = decodeURIComponent(m[1]);
    if (!token) return;
    api('get_shared', { token: token }).then(function (r) {
      if (r && r.list) window.WubsWishlist.showShared(r.list);
      else toast(t('share_not_found', 'Listan hittades inte eller har tagits bort.'));
    }).catch(function () {
      toast(t('share_not_found', 'Listan hittades inte eller har tagits bort.'));
    }).then(function () {
      // Drop the token from the URL so a refresh doesn't reopen it.
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('wl');
        window.history.replaceState({}, '', u.pathname + (u.search || '') + (u.hash || ''));
      } catch (e) {}
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();






